import { render, staticRenderFns } from "./B2.vue?vue&type=template&id=4ec63c6f&"
import script from "./B2.vue?vue&type=script&lang=js&"
export * from "./B2.vue?vue&type=script&lang=js&"
import style0 from "./B2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports